import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  message,
  DatePicker,
  TimePicker,
  Select,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import AppConfigs from "../Config/AppConfig";
import { add, update, list } from "../api/Apis";
import moment from "moment";

const { Option } = Select;
const format = "hh:mm A";

class RequestLead extends Component {
  constructor() {
    super();
    this.state = {
      driversList: [],
      editMode: false,
      startOpen: false,
      endOpen: false,
      startValue: "",
      endValue: "",
      trucks: [],
    };
  }
  setStartValue = (value) => {
    this.setState({
      startValue: value,
    });
    // this.changeFieldValue(value,index,id);
  };
  setEndValue = (value) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("pickupStartTime") >
        this.props.form.getFieldValue("pickupEndTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          pickupEndTime: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          pickupEndTime: this.props.form.getFieldValue("pickupEndTime"),
        });
      }
      //   this.changeFieldValue(value,index,id);
    }
  };

  componentDidMount = () => {
    let leadData = this.props.leadData;
    if ("pickupDate" in leadData && leadData["pickupDate"]) {
      this.props.form.setFieldsValue({
        pickupDate: moment(leadData["pickupDate"], "MM/DD/YYYY"),
        pickupStartTime: moment(leadData["pickupStartTime"], "hh:mm A"),
        pickupEndTime: moment(leadData["pickupEndTime"], "hh:mm A"),
        driver: leadData["driverDetails"]["id"],
        truckNumber: leadData["truckNumber"]
          ? leadData["truckNumber"]
          : leadData["driverDetails"]["truckNumber"]
          ? leadData["driverDetails"]["truckNumber"]
          : leadData["truckDetails"]
          ? leadData["truckDetails"]["truckNumber"]
          : "",
        // "truckNumber": leadData["truckDetails"]["truckNumber"]
      });

      this.setState({
        editMode: true,
      });
    }

    this.getDrivers();
    this.getTrucks();
  };

  getDrivers = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      userProfile: "D",
      orgId: orgDetails["id"],
    };
    list(AppConfigs["entityNames"]["users"], query).then((result) => {
      if (result.success) {
        let drivers = result.data.filter((d) => d.isActive === true);
        this.setState({
          driversList: drivers,
        });
      } else {
        console.log(result.errors);
      }
    });
  };

  getTrucks = async () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));

    let trucks = [];
    orgDetails["carrierFiles"] &&
      orgDetails["carrierFiles"]["trucks"] &&
      orgDetails["carrierFiles"]["trucks"].map((truck, index) => {
        return trucks.push({
          id: index,
          truckNumber: truck["truckNumber"],
          typeOfTruck: truck["typeOfTruck"],
        });
      });
    this.setState({
      orgDetails: orgDetails,
      trucks: trucks,
      dataLoadingStatus: false,
    });
  };

  requestLead = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        let pickupDate = moment(values["pickupDate"]).format("MM/DD/YYYY");
        let pickupStartTime = moment(values["pickupStartTime"]).format(
          "hh:mm A"
        );
        let pickupEndTime = moment(values["pickupEndTime"]).format("hh:mm A");
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let data = {};
        let driverDetails = this.state.driversList.filter(
          (driver) => driver.id === values["driver"]
        );
        let truckDetails = this.state.trucks.filter(
          (truck) => truck.truckNumber === values["truckNumber"]
        );

        if (
          this.props.leadData["orderStatus"] === "AC" ||
          this.props.leadData["orderStatus"] === "I"
        ) {
          data = {
            entityData: {
              pickupDate: pickupDate,
              pickupStartTime: pickupStartTime,
              pickupEndTime: pickupEndTime,
              driverDetails: {
                name:
                  driverDetails[0]["firstName"] +
                  " " +
                  driverDetails[0]["lastName"],
                phone: driverDetails[0]["phone"],
                // "truckNumber": values["truckNumber"],
                id: driverDetails[0]["id"],
              },
              truckDetails: {
                truckNumber: truckDetails[0]["truckNumber"],
                typeOfTruck: truckDetails[0]["typeOfTruck"],
                id: truckDetails[0]["id"],
              },

              orderStatus: AppConfigs["IN_PROGRESS"],
            },
          };
          if (!this.state.editMode) {
            data["entityData"]["driverDetails"] = {
              name:
                driverDetails[0]["firstName"] +
                " " +
                driverDetails[0]["lastName"],
              phone: driverDetails[0]["phone"],
              // "truckNumber": values["truckNumber"],
              id: driverDetails[0]["id"],
            };
            data["entityData"]["truckDetails"] = {
              truckNumber: truckDetails[0]["truckNumber"],
              typeOfTruck: truckDetails[0]["typeOfTruck"],
              id: truckDetails[0]["id"],
            };
            // data["entityData"]["driverDetails"]["truckNumber"] = values["truckNumber"]
          }
          update(
            AppConfigs["entityNames"]["leads"],
            this.props.leadData["id"],
            data
          ).then((result) => {
            if (result.success) {
              this.props.hideModal();
              message.success("Pickup date and time updated successfully!");
              if (this.props.callFrom === "orders") {
                this.props.getOrders();
              } else {
                this.props.getLoadDetails();
              }
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });
        } else {
          data = {
            entityData: {
              leadId: this.props.leadData["id"],
              carrierId: orgDetails["id"],
              carrierName: orgDetails["companyName"],
              rateValue: this.props.leadData["rateValue"],
              callForRate: this.props.leadData["callForRate"],
              rateAmt: this.props.leadData["rateAmt"],
              rateOption: this.props.leadData["rateOption"],
              pickupDate: pickupDate,
              pickupStartTime: pickupStartTime,
              pickupEndTime: pickupEndTime,
              driverDetails: {
                name:
                  driverDetails[0]["firstName"] +
                  " " +
                  driverDetails[0]["lastName"],
                phone: driverDetails[0]["phone"],
                // "truckNumber": values["truckNumber"],
                id: driverDetails[0]["id"],
              },
              truckDetails: {
                truckNumber: truckDetails[0]["truckNumber"],
                typeOfTruck: truckDetails[0]["typeOfTruck"],
                id: truckDetails[0]["id"],
              },
              carrierEmail: orgDetails["email"],
              // "truckNumber": values["truckNumber"],
              orderStatus: AppConfigs["IN_PROGRESS"],
            },
          };
          add(AppConfigs["assignLead"], data).then((result) => {
            if (result.success) {
              this.props.hideModal();
              message.success("Load assigned successfully!");
              if (this.props.callFrom === "orders") {
                this.props.getOrders();
              } else {
                this.props.getLoadDetails();
              }
            } else {
              this.setState({
                loading: false,
              });
              // message.error(result.errors);
              console.log(result.errors);
              this.props.history.push("/carrier_app/allOrders");
            }
          });
        }
      }
    });
  };

  setEndValue = (value) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("pickupStartTime") >
        this.props.form.getFieldValue("pickupEndTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          pickupEndTime: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          pickupEndTime: this.props.form.getFieldValue("pickupEndTime"),
        });
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    // let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    return (
      <main>
        {/* {   this.props.callFrom === "orders" ?
                        <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }} onClick={() => { this.showModal() }}>Request Load</span>
                    :
                        <h3 style={{ color: '#fff' }}>
                            <Button style={{ background: '#0e4d90', borderColor: '#FFF', color: '#FFF' }} onClick={() => { this.showModal() }}>
                            Request this Load
                            </Button>
                        </h3>
                } */}
        <Form>
          <Modal
            visible={this.props.modalStatus}
            closable={true}
            footer={[
              <Button
                key="cancel"
                className="cancel"
                onClick={() => {
                  this.setState({ loading: false });
                  this.props.hideModal();
                }}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.requestLead}
              >
                Submit
              </Button>,
            ]}
          >
            {/* <Button key="cancel" style={{float:"right"}} onClick={() => {this.props.hideModal() }} >
                            X
                        </Button> */}
            <div>
              <Row>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ textAlign: "right" }}
                >
                  <CloseOutlined
                    onClick={() => {
                      this.props.hideModal();
                    }}
                    style={{ cursor: "pointer", fontSize: "1.4em" }}
                  />
                </Col>
              </Row>
              <Row gutter={10}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Pickup Date</span>}
                  >
                    {getFieldDecorator("pickupDate", {
                      rules: [
                        { required: true, message: "Please input pickup date" },
                      ],
                    })(
                      <DatePicker
                        format="MM-DD-YYYY"
                        // disabledDate={(current) => {
                        // return current && current.valueOf() < Date.now();
                        // }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Pickup Time</span>}
                    required={true}
                  />
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item>
                      {getFieldDecorator("pickupStartTime", {
                        rules: [
                          {
                            required: true,
                            message: "Please input pickup start time",
                          },
                        ],
                      })(
                        <TimePicker
                          placeholder="Start Time"
                          format={format}
                          use12Hours
                          defaultOpenValue={moment("00:00", "hh:mm A")}
                          minuteStep={15}
                          // open={this.state.startOpen}
                          onOpenChange={(startOpen) =>
                            this.setState({ startOpen })
                          }
                          onChange={(value) =>
                            this.setStartValue(value, "pickupStartTime")
                          }
                          // onChange={this.setStartValue}
                          // disabledHours={this.getStartDisabledHours}
                          // disabledMinutes={this.getStartDisabledMinutes}

                          // addon={() => (
                          //   <Button size="small" type="primary" onClick={() => this.setState({ startOpen: false })}>
                          //     Ok
                          //   </Button>
                          // )}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item>
                      {getFieldDecorator("pickupEndTime", {
                        rules: [
                          {
                            required: true,
                            message: "Please input  pickup end time",
                          },
                        ],
                      })(
                        <TimePicker
                          placeholder="End Time"
                          format={format}
                          use12Hours
                          defaultOpenValue={moment("00:00", "hh:mm A")}
                          minuteStep={15}
                          // open={this.state.endOpen}
                          // onOpenChange={() => this.setState({ endOpen: true })}
                          onOpenChange={(value) =>
                            this.setEndValue(value, "pickupEndTime")
                          }

                          //     addon={() => (
                          //     <Button size="small" type="primary" onClick={() => this.setState({ endOpen: false })}>
                          //       Ok
                          //     </Button>
                          //   )}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "black" }}>Driver</span>}
                  >
                    {getFieldDecorator("driver", {
                      rules: [
                        { required: true, message: "Please select driver" },
                      ],
                    })(
                      <Select
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Please Select"
                        showArrow
                      >
                        {this.state.driversList.map((driver) => (
                          <Option value={driver["id"]} key={driver["id"]}>
                            {driver["firstName"] + " " + driver["lastName"]}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                {/* <Col lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item className="Formitem"
                                        label={<span style={{ color: 'black' }}>Truck</span>} >
                                        {getFieldDecorator('truckNumber',
                                            {
                                                rules: [{ required: true, message:"Please select truck" }],
                                            }
                                        )(
                                            <Select allowClear style={{ width: '100%' }} placeholder="Please Select" showArrow>
                                                {
                                                    "carrierFiles" in orgDetails && orgDetails["carrierFiles"]["trucks"] && orgDetails["carrierFiles"]["trucks"].map((truck) => 
                                                        <Option value={truck["truckNumber"]} key={truck["truckNumber"]}>{truck["truckNumber"]}</Option>
                                                    )
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col> */}
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "black" }}>Truck</span>}
                  >
                    {getFieldDecorator("truckNumber", {
                      rules: [
                        { required: true, message: "Please select truck" },
                      ],
                    })(
                      <Select
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Please Select"
                        showArrow
                      >
                        {this.state.trucks.map((truck) => (
                          <Option
                            value={truck["truckNumber"]}
                            key={truck["truckNumber"]}
                          >
                            {truck["truckNumber"]}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Modal>
        </Form>
      </main>
    );
  }
}

export default Form.create({ name: "RequestLead" })(RequestLead);
